<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单号</label>
            <em class="weui-form-preview__value">{{ form.main.pc_code }}</em>
          </div>
        </div>
      </div>
      <div class="form-preview weui-form-preview">
        <div class="weui-panel__hd">基础信息</div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料编号</label>
            <span class="weui-form-preview__value">{{
              form.main.pc_prcode_old
            }}</span>
          </div>
          <change-field
            label="物料名称"
            :old-value="oldItem.pr_detail"
            :new-value="newItem.pr_detail"
          />
          <change-field
            label="规格"
            :old-value="oldItem.pr_spec"
            :new-value="newItem.pr_spec"
          />
          <change-field
            label="型号"
            :old-value="oldItem.pr_orispeccode"
            :new-value="newItem.pr_orispeccode"
          />
          <change-field
            label="单位"
            :old-value="oldItem.pr_unit"
            :new-value="newItem.pr_unit"
          />
          <change-field
            label="品牌"
            :old-value="oldItem.pr_brand"
            :new-value="newItem.pr_brand"
          />
          <change-field
            label="类型"
            :old-value="oldItem.pr_kind"
            :new-value="newItem.pr_kind"
          />
          <change-field
            label="检验类型"
            v-if="isMakeApp"
            :old-value="oldItem.pr_iqc_type"
            :new-value="newItem.pr_iqc_type"
          />
          <change-field
            label="生产类型"
            v-if="isMakeApp"
            :old-value="parseManuType(oldItem.pr_manutype)"
            :new-value="parseManuType(newItem.pr_manutype)"
          />
          <change-field
            label="仓库"
            :old-value="oldItem.pr_whname"
            :new-value="newItem.pr_whname"
          />
          <change-field
            label="最小包装数"
            :old-value="oldItem.pr_zxbzs"
            :new-value="newItem.pr_zxbzs"
          />
          <change-field
            label="最小订购量"
            :old-value="oldItem.pr_moq"
            :new-value="newItem.pr_moq"
          />
          <change-field
            label="采购周期"
            :old-value="oldItem.pr_leadtime"
            :new-value="newItem.pr_leadtime"
          />
          <change-field
            label="标准损耗"
            v-if="isMakeApp"
            :old-value="oldItem.pr_lossrate"
            :new-value="newItem.pr_lossrate"
          />
          <change-field
            label="每日产能"
            v-if="isMakeApp"
            :old-value="oldItem.pr_dailycapacity"
            :new-value="newItem.pr_dailycapacity"
          />
          <change-field
            label="发料类型"
            v-if="isMakeApp"
            :old-value="parseSeparable(oldItem.pr_separable)"
            :new-value="parseSeparable(newItem.pr_separable)"
          />
          <change-field
            label="标准售价（元）"
            :old-value="oldItem.pr_standardprice"
            :new-value="newItem.pr_standardprice"
          />
          <change-field
            label="供应商"
            :old-value="oldItem.pr_vendname"
            :new-value="newItem.pr_vendname"
          />
          <change-field
            label="安全库存"
            :old-value="oldItem.pr_safetystock"
            :new-value="newItem.pr_safetystock"
          />
          <change-field
            label="税控分类编码"
            :old-value="oldItem.pr_taxcode"
            :new-value="newItem.pr_taxcode"
          />
          <change-field
            label="开票品名"
            :old-value="oldItem.pr_billitemname"
            :new-value="newItem.pr_billitemname"
          />
          <change-field
            label="备注"
            :old-value="oldItem.pr_remark"
            :new-value="newItem.pr_remark"
          />
          <change-field
            label="附件"
            :old-value="oldItem.pr_attach"
            :new-value="newItem.pr_attach"
          >
            <template v-slot:old="slotProps">
              <file-list v-model="slotProps.value" />
            </template>
            <template v-slot:new="slotProps">
              <file-list v-model="slotProps.value" />
            </template>
          </change-field>
        </div>
      </div>
      <div class="form-preview weui-form-preview">
        <div class="weui-panel__hd">变更信息</div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">变更人</label>
            <span class="weui-form-preview__value">{{
              form.main.creatorName
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">变更日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.createTime
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">审核人</label>
            <span class="weui-form-preview__value">{{
              form.main.pc_auditman
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">审核日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.pc_auditdate
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FileList from "@/components/FileList.vue";
import ChangeField from "@/components/field/ChangeField";
import form from "@/mixins/form.js";

export default {
  mixins: [form],
  components: {
    FileList,
    ChangeField,
  },
  data() {
    return {
      baseUrl: "/api/document/productchange",
    };
  },
  computed: {
    oldItem() {
      var items = this.form.items;
      return items && items.length == 2 ? items[0] : {};
    },
    newItem() {
      var items = this.form.items;
      return items && items.length == 2 ? items[1] : {};
    },
  },
  methods: {
    parseManuType(type) {
      return { PURCHASE: "外购", MAKE: "自制", OSMAKE: "委外" }[type];
    },
    parseSeparable(separable) {
      return { 0: "按最小包装发料", 1: "可以拆包发料" }[separable];
    },
  },
};
</script>